"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterLocalDateTimeCell = exports.FilterInstantDateTimeCell = exports.DisabledFilterDateTimeCell = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const field_filter_api_1 = require("../field-filter-api");
const field_filter_styles_1 = require("../field-filter-styles");
const field_filter_hook_1 = require("../field-filter-hook");
const select_1 = require("../../select/select");
const date_time_field_1 = require("../../date-time-field/date-time-field");
function DisabledFilterDateTimeCell(props) {
    return react_1.default.createElement(FilterDateTimeCell, Object.assign({}, props, { disabled: true }));
}
exports.DisabledFilterDateTimeCell = DisabledFilterDateTimeCell;
exports.FilterInstantDateTimeCell = (props) => (react_1.default.createElement(FilterDateTimeCell, Object.assign({}, props, { representation: "instant" })));
exports.FilterLocalDateTimeCell = (props) => (react_1.default.createElement(FilterDateTimeCell, Object.assign({}, props, { representation: "local-date-time" })));
function FilterDateTimeCell({ disabled, value, onChange, state, onChangeState, representation, }) {
    const classes = field_filter_styles_1.useFilterStyles();
    const operations = field_filter_api_1.useCompareOperations();
    const { handleChangeOperation } = field_filter_hook_1.useFilterOperation(state, onChangeState);
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.root, { [classes.disabled]: disabled }) },
        react_1.default.createElement("div", { className: classes.selectWrapper },
            react_1.default.createElement(select_1.Select, { source: operations, value: state.operation, onChange: handleChangeOperation, valueIsId: true, clearable: false, disabled: disabled })),
        react_1.default.createElement("div", { className: classes.textWrapper },
            react_1.default.createElement(date_time_field_1.DateTimeField, { representation: representation, value: value, onChange: onChange, disabled: disabled }))));
}
//# sourceMappingURL=filter-date-time-cell.js.map